module.exports = __webpack_public_path__ + "static/media/High_carb.ba450458.jpg";